var createReactClass = require('create-react-class');
import React from 'react';

const InReview = ({article, renderEmailEditingReceipt}) => {

  return(
    <React.Fragment>
        {renderEmailEditingReceipt()}
    </React.Fragment>
  )
}

export default InReview;